// import "searchkit/theming/theme.scss";
import * as React from "react";
import * as ReactDOM from "react-dom";
// import {App} from "./app";
// import {FormBuilder} from "./form-builder";
import {ProfilePage, PDFProfile} from "./profile";
import {ProfileGrid} from "./profile/grid";
import defaultProfileData from './profile/data'

// const isPDF = window.location.href.indexOf("pdf") != -1
const isPDF = false;
console.log("isPDF", isPDF)

function loadProfile(id, profile=defaultProfileData){
  ReactDOM.render((
    <ProfilePage profile={profile}  isPDF={isPDF} />
  ), document.getElementById(id));
}
function loadPDFProfile(id, profile=defaultProfileData){
  ReactDOM.render((
    <PDFProfile profile={profile}/>
  ), document.getElementById(id));
}

function profileGrid(id, profiles, options={}){
  ReactDOM.render((
    <ProfileGrid profiles={profiles} {...options} />
  ), document.getElementById(id));
}



window.AppCraft = window.AppCraft || {}
window.AppCraft.loadProfile = loadProfile
window.AppCraft.loadPDFProfile = loadPDFProfile
window.AppCraft.profileGrid = profileGrid
console.log("Loaded AppCraft scripts")
if (window.AppCraft.onload){
  window.AppCraft.onload.forEach(f => f())
}

// if (__AC_MODE === "form-builder"){
//   ReactDOM.render((
//     <ProfilePage />
//   ), document.getElementById('root'));
// } else if(__AC_MODE === "landscape"){
//   ReactDOM.render((
//     <Landscape />
//   ), document.getElementById('root'));
// } else {
if (document.getElementById('root')){
  loadProfile('root')
  // loadProfile2('root')
  // editProfile('root')
}
// }



/** WEBPACK FOOTER **
 ** ./src/cjtalents.jsx
 **/